import gql from 'graphql-tag';

import categoryFragment from '~/shared/graphql-queries/categories/category-fragment';

export default gql`
  query findByIdCategoryQuery($_id: MongoID!) {
    findByIdCategoryQuery(_id: $_id) {
      ...CategoryFragment
    }
  }
  ${categoryFragment}
`;
